import { createRouter, createWebHistory } from 'vue-router'

import Home         from './pages/Home'
import Test         from './pages/Test'
// import About        from './pages/About'
import PageNotFound from './pages/404'

export const routes = [
    { path: '/business_character_test/test/:id', component: Test,  name: 'test'  },
    { path: '/business_character_test/:id',      component: Home,  name: 'home'  },
    // { path: '/enneagram_test/about',    component: About, name: 'about' },
    // { path: '*',            component: PageNotFound,    name: '404' },
]

const DEFAULT_TITLE = 'ビジネスキャラ診断'

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.afterEach((to, from) => {
    document.title = to.meta.title || DEFAULT_TITLE
})
export default router
